import IDream from "motw_core/Entity/IDream";
import { hashTagsService } from "motw_core/Services/HashTagsService";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import Data from "source/app/services/Data";
import { IDreamsState } from "../../IDreamsState";
import { UpdateLocalDreamState } from "source/app/presentation/MainPanel/Dreams/Controls/Difficulty/QuickSelector/UpdateLocalDreamState";
import { hashTag_thisweek } from "motw_core/Constants/constants";
import { dreamService } from "motw_core/Services/DreamService";

export async function HandleHashTagLinkDropAsync(
    dream: IDream,
    hashTag: string
) {
    const doesDreamContainHashTag = hashTagsService.DoesDreamHaveHashTag(
        dream,
        hashTag
    );

    if (doesDreamContainHashTag) {
        const updatedDream = {
            ...dream,
            name: hashTagsService.GetStringWithoutHashTag(dream.name, hashTag),
        };

        UpdateLocalDreamState(updatedDream);

        await hashTagsService.RemoveHashTagFromDreamAsync(
            dream,
            hashTag,
            ClientDataProvider
        );
    } else {
        const updatedDream = {
            ...dream,
            name: hashTagsService.GetStringWithHashTag(dream.name, hashTag),
            isresonating:
                hashTag === hashTag_thisweek ? false : dream.isresonating,
        };

        UpdateLocalDreamState(updatedDream);

        await hashTagsService.AddHashTagToDreamAsync(
            dream,
            hashTag,
            ClientDataProvider
        );
    }

    return Data.Load.Single.ByStateTarget<IDreamsState>("dreamsdata");
}

export async function HandleThisWeekDropAsync(dream: IDream) {
    if (hashTagsService.DoesDreamHaveHashTag(dream, hashTag_thisweek)) {
        return;
    }

    const updatedDream = {
        ...dream,
        name: hashTagsService.GetStringWithHashTag(dream.name, hashTag_thisweek),
        isresonating: false,
    };

    UpdateLocalDreamState(updatedDream);

    await hashTagsService.AddHashTagToDreamAsync(
        dream,
        hashTag_thisweek,
        ClientDataProvider
    );

    return Data.Load.Single.ByStateTarget<IDreamsState>("dreamsdata");
}

export async function HandleTodayDropAsync(dream: IDream) {
    const updatedDream = {
        ...dream,
        name: hashTagsService.GetStringWithoutHashTag(
            dream.name,
            hashTag_thisweek
        ),
        isresonating: true,
    };

    UpdateLocalDreamState(updatedDream);

    await dreamService.UpdateDreamAsync(updatedDream, ClientDataProvider);

    return Data.Load.Single.ByStateTarget<IDreamsState>("dreamsdata");
}
